import { render, staticRenderFns } from "./NoFlows.vue?vue&type=template&id=cf0bbe88&scoped=true"
import script from "./NoFlows.vue?vue&type=script&lang=js"
export * from "./NoFlows.vue?vue&type=script&lang=js"
import style0 from "./NoFlows.vue?vue&type=style&index=0&id=cf0bbe88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0bbe88",
  null
  
)

export default component.exports